
import React from "react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

interface AmountFieldProps {
  amount: {
    value: string;
    unit: string;
  };
  onChange: (amount: { value: string; unit: string }) => void;
  error?: string;
}

const commonUnits = ["g", "mg", "µg", "kg", "L", "mL", "µL", "M", "mM", "µM", "nM", "pM"];

const AmountField: React.FC<AmountFieldProps> = ({ amount, onChange, error }) => {
  const handleValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange({
      ...amount,
      value: e.target.value
    });
  };

  const handleUnitChange = (unit: string) => {
    onChange({
      ...amount,
      unit
    });
  };

  return (
    <div className="space-y-2">
      <Label htmlFor="amount-value">
        Amount <span className="text-red-500">*</span>
      </Label>
      <div className="flex gap-2">
        <div className="flex-grow">
          <Input
            id="amount-value"
            value={amount.value}
            onChange={handleValueChange}
            placeholder="e.g. 500"
            className={error ? "border-red-500" : ""}
          />
        </div>
        <div className="w-24">
          <Select value={amount.unit} onValueChange={handleUnitChange}>
            <SelectTrigger id="amount-unit" className={error ? "border-red-500" : ""}>
              <SelectValue placeholder="Unit" />
            </SelectTrigger>
            <SelectContent>
              {commonUnits.map((unit) => (
                <SelectItem key={unit} value={unit}>
                  {unit}
                </SelectItem>
              ))}
              <SelectItem value="custom">Custom</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>
      {error && <p className="text-red-500 text-sm">{error}</p>}
    </div>
  );
};

export default AmountField;
